import {
  AccountPaymentMethod,
  PadEnforcementRule,
  PadTwikeyRedirectCheckoutFlow,
  PadVerifiedStatus,
  PaymentAccount,
  PaymentAccountBurnVerified,
  PreAuthorizedDebitMode,
  SessionType,
} from '../models';

export function resolvePadVerifiedStatus(
  paymentAccountBurnVerified: PaymentAccountBurnVerified,
): PadVerifiedStatus {
  const padVerifiedStatus: PadVerifiedStatus = {
    padVerified: paymentAccountBurnVerified.isAuthorized,
    padSignedSeparately:
      paymentAccountBurnVerified.mandateId == null &&
      paymentAccountBurnVerified.isAuthorized,
  };
  return padVerifiedStatus;
}

export function setPadVerifiedStatusOnBankAccounts(
  paymentAccounts: PaymentAccount[],
  bankAccountPadVerifiedStatus: PaymentAccountBurnVerified[],
): PaymentAccount[] {
  const updatedPaymentAccounts = paymentAccounts.map((paymentAccount) => {
    const bankAccountVerifiedStatus = bankAccountPadVerifiedStatus.find(
      (bankAccount) =>
        bankAccount.paymentAccountBurn ==
        paymentAccount.paymentAccountIdentifierBurn,
    );
    if (bankAccountVerifiedStatus) {
      return {
        ...paymentAccount,
        padVerifiedStatus: resolvePadVerifiedStatus(bankAccountVerifiedStatus),
      };
    } else {
      return paymentAccount;
    }
  });

  return updatedPaymentAccounts;
}

export function updatePadVerifiedStatus(
  paymentAccounts: PaymentAccount[],
  bankAccountPadVerifiedStatus: PaymentAccountBurnVerified,
): PaymentAccount[] {
  return paymentAccounts.map((paymentAccount) => {
    if (
      paymentAccount.paymentAccountIdentifierBurn ===
      bankAccountPadVerifiedStatus.paymentAccountBurn
    ) {
      return {
        ...paymentAccount,
        padVerifiedStatus: resolvePadVerifiedStatus(
          bankAccountPadVerifiedStatus,
        ),
      };
    }
    return paymentAccount;
  });
}

export function convertPadModeToPadEnforcementRule(
  padMode: PreAuthorizedDebitMode,
): PadEnforcementRule {
  switch (padMode) {
    case PreAuthorizedDebitMode.Required:
      return PadEnforcementRule.Required;
    case PreAuthorizedDebitMode.Optional:
      return PadEnforcementRule.Optional;
    case PreAuthorizedDebitMode.NotRequired:
      return PadEnforcementRule.NotRequired;
    default:
      return PadEnforcementRule.Unknown;
  }
}

export function getPadTwikeyRedirectCheckoutFlow(
  sessionType: SessionType,
  originatingApplication: string,
): PadTwikeyRedirectCheckoutFlow {
  switch (sessionType) {
    case SessionType.PayOtherAmount:
      return PadTwikeyRedirectCheckoutFlow.PayOther;
    case SessionType.PayOnAccount:
      if (originatingApplication === 'PAYMENTLINKS')
        return PadTwikeyRedirectCheckoutFlow.PaymentLinksPayOnAccount;
      return PadTwikeyRedirectCheckoutFlow.PayOnAccount;
    case SessionType.HostedPaymentsPage:
      if (originatingApplication === 'HOSTEDPAYMENTSVALIDATING')
        return PadTwikeyRedirectCheckoutFlow.GuestCheckoutValidating;
      else return PadTwikeyRedirectCheckoutFlow.GuestCheckoutNonValidating;
    default:
      if (originatingApplication == 'PAYMENTLINKS')
        return PadTwikeyRedirectCheckoutFlow.PaymentLinks;
      return PadTwikeyRedirectCheckoutFlow.PayOnInvoice;
  }
}

export function isBankAccountPadVerified(
  account: PaymentAccount,
  isCanadianPadRequiredFlow: boolean,
  isCanadianPadOptionalFlow: boolean,
): boolean {
  if (account.paymentMethod != AccountPaymentMethod.Ach) {
    return true;
  } else if (isCanadianPadRequiredFlow) {
    return (
      account.padVerifiedStatus?.padVerified &&
      !account.padVerifiedStatus?.padSignedSeparately
    );
  } else if (isCanadianPadOptionalFlow) {
    return account.padVerifiedStatus?.padVerified;
  } else return true;
}
